import onboarding from 'assets/images/onboarding.png'
import SessionConst from 'constants/SessionConst'
import React, { Component } from 'react'
import { IconContext } from "react-icons"
import { FaExclamationCircle, FaLock, FaLockOpen } from 'react-icons/fa'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { isArrayNotEmpty, isObjectEmpty, removeHotelInfoFromSession, removeHotelOnboardingStatusFromSession, removeLockStatusFromSession } from 'utilities/JSUtil'
import * as FormConst from '../../constants/FormConst'
import RouteConst from '../../constants/RouteConst'
import { asyncMethod } from '../../redux/actions'
import * as actionTypes from '../../redux/actionTypes'
import HotelHistoryService from '../../services/HotelHistoryService'
import { getSessionItem } from '../../utilities/SessionHelper'
import Button from '../atoms/Button/Button'
import FormModal from '../organisms/FormModal/FormModal'
import './SearchHotelHistoryDetails.scss'
import './SearchHotel.scss'
import Table from '../molecules/Table/Table'
import ReactJson from 'react-json-view'
import Pagination from '../organisms/Pagination/Pagination'


class SearchHotelHistoryDetails extends Component {

    constructor(props) {
        super(props)
        removeHotelInfoFromSession()
        removeLockStatusFromSession()
        let user = getSessionItem(SessionConst.USER)
    
        if (!user || isObjectEmpty(user) || !isArrayNotEmpty(this.props.location?.state?.historyRecords)) {
          this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            sessionData: null,
            hotelCode: this.props.location?.state?.hotelCode,
            searchHotelHistoryDetailsList: this.props.location?.state?.historyRecords || [],
            expandHistoryRecordDetails:'',
            errorMessage: undefined,
            currentUser: getSessionItem(SessionConst.USER).username,
            isLoading: false,
            isUpdateLock: false,
            editIndex: -1,
            hotelOnboardingId: this.props.location?.state?.hotelOnboardingId,
            total: this.props.location?.state?.total,
            limit: 10
        }

        this.getData = this.getData.bind(this);
    }

    redirectToSearch = () => {
        this.props.history.push({
            pathname: RouteConst.ROUTE_HISTORY_SEARCH_PAGE,
            state: {
                hotelCode: this.state.hotelCode
            }
        })
    }

    handleErrorModalCancel = () => {
        this.setState({ errorMessage: undefined })
    }

    expandHistoryRecord = (index) => {
        this.setState({ expandHistoryRecordDetails: this.state.searchHotelHistoryDetailsList[index]})
    }

    getData = (offset) => {
        this.setState({isLoading: true})

        HotelHistoryService.getHotelOnboardingHistoryDetails(this.state.hotelOnboardingId, offset, this.state.limit)
            .then(historyResponse => {
                if (historyResponse?.hotelOnboardingHistoryItems?.hotelOnboardingItems.length > 0) {
                    this.setState({
                        searchHotelHistoryDetailsList: historyResponse.hotelOnboardingHistoryItems.hotelOnboardingItems,
                        isLoading: false
                    })
                }
            }).catch(error => {
                this.setState({ 
                    searchHotelHistoryDetailsList: [],
                    errorMessage: 'No onboarding details found', 
                    isLoading: false })
            })        
    }

    render() {

        return (

            <div className='search-hotel-history-list-page'>
                <img id='page-logo' src={onboarding} className='onboarding-img' />
                <div className='search-hotel-list'>
                    <Button id='search-page-button-top' name='Go to History search page' className='search-button' onClick={this.redirectToSearch} />
                    <p id='search-page-info' className='search-hotel-list-header'>Onboarding History Record Details for an Hotel: {this.state.hotelCode} with HOG Id: {this.state.searchHotelHistoryDetailsList[0]?.newEntity.hotelOnboardingId} </p>

                    <table
                        id='search-page-application-list-table'
                        className='table table-striped search-hotel-list-table'
                    >
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Hotel Code</th>
                                <th>Requestor</th>
                                <th>Status</th>
                                <th>Type</th>
                                <th>Expand</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                isArrayNotEmpty(this.state.searchHotelHistoryDetailsList)
                                    ? (
                                        this.state.searchHotelHistoryDetailsList.map((historyRecord, index) =>
                                            <>
                                                <tr key={index} class="accordion-toggle collapsed" id={`accordion${index}`} data-toggle="collapse" data-parent={`#accordion${index}`} href={`#collapse${index}`}>
                                                    <td>{historyRecord.timestamp}</td>
                                                    <td>{this.state.hotelCode}</td>
                                                    <td>{historyRecord.requestor}</td>
                                                    <td>{historyRecord.newEntity.status}</td>
                                                    <td>{historyRecord.type}</td>
                                                    <td className="expand-button"></td>
                                                </tr>

                                                <tr class="hide-table-padding">
                                                <td colSpan="6"> 
                                                    <div id={`collapse${index}`} className="collapse in p-3">
                                                       <ReactJson src={historyRecord} />
                                                    </div>
                                                </td>
                                                </tr>
                                     
                                            </>
                                        )
                                    )
                                    : (
                                        <tr>
                                            <td colSpan={6} className='text-center'>No records found</td>
                                        </tr>
                                    )
                            }
                        </tbody>
                    </table>
                    
                    <Pagination 
                        total={this.state.total}
                        pageLimit={this.state.limit}
                        getData={this.getData} />

                    <Button
                        id='search-page-search-page-button-bottom'
                        name='Go to History search page'
                        className='search-button'
                        onClick={this.redirectToSearch} />

                    <FormModal
                        id='search-page-error-modal'
                        title='Error'
                        body={
                            <>
                                <p>{this.state.errorMessage}</p>
                                <p>Tracking id:</p>
                                <p className='text-bold'>{getSessionItem(SessionConst.TRACKING_ID)}</p>
                            </>
                        }
                        hotelInfo={this.state.hotelInfo}
                        show={!!this.state.errorMessage}
                        cancel={this.handleErrorModalCancel} />

                    <FormModal
                        id='next-page-loading-modal'
                        title={FormConst.MODAL_READ_ACTION_TITLE}
                        hotelInfo={this.state.hotelInfo}
                        body={<h5>{FormConst.MODAL_READ_ACTION_TEXT}</h5>}
                        show={this.state.isLoading}
                        isLoadingIndicator />
                </div>
            </div>
        )
    }

}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        lockStatusResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        count: state.reducer.count,
        httpAction: state.reducer.httpAction
    }
}

const mapDispatchToProps = dispatch => {
    return {
        acquireUser: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_ADMIN_PAGE_NAME, actionTypes.ASYNC_ACTIONS.ACQUIRE_USER, { hotelCode: hotelCode })),
        resetUser: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_ADMIN_PAGE_NAME, actionTypes.ASYNC_ACTIONS.RESET_USER, { hotelCode: hotelCode }))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SearchHotelHistoryDetails))